// React
import { memo } from "react";

// UI
import { Badge } from "ui/components/Badge";
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { METERED_ITEM_COLUMNS } from "./consts";
import { MeteredItemsCardProps } from "./types";

/**
 * Mjereni troškovi — prodajna cijena, naš trošak i marža.
 *
 * Marža je izračunati stupac; nigdje se ne sprema. Naš trošak se vidi samo ovdje — nijedan
 * drugi ekran ni endpoint ga ne vraća.
 */
const MeteredItemsCard: React.FC<MeteredItemsCardProps> = (props: MeteredItemsCardProps) => {
  const { items } = props;

  return (
    <div className="p-6">
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px]">
          <p className="text-base font-bold text-slate-600 py-3">Mjereni troškovi</p>
          <p className="text-sm text-slate-500">
            Naplaćuje se po jedinici. Marža se računa iz prodajne cijene i našeg troška.
          </p>

          <div className="mt-3">
            <Badge
              text="Naš trošak se ne prikazuje nigdje izvan ovog ekrana"
              variant="secondary"
              height="small"
            />
          </div>
        </div>

        <div className="flex-1">
          {items.length === 0 ? (
            <p className="text-sm text-slate-400 py-3">Ova verzija nema mjerenih stavki.</p>
          ) : (
            <div>
              <TableSearch
                columns={METERED_ITEM_COLUMNS}
                data={items}
                selectableRows={false}
                disablePagination
              />

              <p className="text-xs text-slate-400 mt-3">
                Marža ispod 30 % je označena. Poseban uvjet na toj razini traži odobrenje.
              </p>

              {/*
                Marža i pragovi odobravanja računaju se iz stupca „Naš trošak", ne iz
                izmjerenog. Ako se razidu, štite pogrešnu brojku — zato izmjereno stoji uz
                njega, umjesto da se razmak vidi tek kad netko ode u minus.
              */}
              <p className="text-xs text-slate-400 mt-1">
                Marža se računa iz našeg troška u cjeniku, ne iz izmjerenog. Izmjereno je u
                dolarima i ne pretvara se — služi za usporedbu, ne za obračun.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(MeteredItemsCard);
